import React, { forwardRef } from 'react';
import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';
import { useTheme } from '@mui/material/styles';

// ----------------------------------------------------------------------

// Sửa tên component thành CustomLoadingButton và sử dụng LoadingButtonProps
const CustomLoadingButton = forwardRef<HTMLButtonElement, LoadingButtonProps>((props, ref) => {
  const theme = useTheme();

  return (
    <LoadingButton
      ref={ref}
      variant="contained"
      color="primary"
      {...props}
      sx={{
        // Áp dụng màu chủ đạo (main) cho nền
        backgroundColor: theme.palette.primary.main,
        
        // Ghi đè hiệu ứng hover/press
        '&:hover': {
          backgroundColor: theme.palette.primary.dark,
          // Giữ nguyên màu text khi hover
        },
        // Xử lý khi nút bị disabled (quan trọng cho LoadingButton)
        '&.Mui-disabled': {
            // Dùng màu xám để phân biệt nhưng vẫn giữ được độ đậm (Dark mode friendly)
            backgroundColor: theme.palette.grey[400], 
            color: theme.palette.grey[700],
        },
        // Hợp nhất các style tùy chỉnh khác
        ...props.sx, 
      }}
    >
      {/* Không cần eslint-disable-next-line cho props.children khi dùng forwardRef */}
      {props.children}
    </LoadingButton>
  );
});

export default CustomLoadingButton;